export default {
	addService: '/service', //新增账户
	editService: '/service', //编辑账户
	reOrder: '/service/order',
	getServiceList: '/service/list',
	getServiceDetail: '/service/',
	getWebsiteByCustomer: '/service/sites/',
	// 行业报告
	getIndustryList: '/sys/industry/foreign/{parentId}', //获取行业信息
	industryReport: '/admin/industry/effect/report', //发送行行业报告请求
	getReportServiceList: '/service/service-list', // 报告下载-优化师归属的服务单
	effectServiceList: '/service/effect-service-list', // 有效服务单
	edmCupyNumcheck: '/service/edmoccupynumcheck', // 邮箱占用检查
	fillbindinfo: '​/chuanglan/fillbindinfo', // 创建 WABA-添加绑定信息
	bindPhone: '/chuanglan/phonebind', // 创建 WABA-绑定手机号
	startService: '/service/start/{id}' , // 开始服务
};
